import React from 'react';
import {NavLink, Outlet} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import useOnline from '../hooks/useOnline';

const {FiFilePlus, FiFolder, FiWifiOff} = FiIcons;

const roavynArtworkUrl = 'https://media-manager-c.questera.ai/greta-media/158533d8ca4f4551c8e29b071a3b899789fe177c9640e9342f6004a01a089397fd568b7a70d6299c112a3245b06d560e/images/aW1hZ2UvcG5n/dd8bb27a6b9b6e474c2a28a8aeb6e626.png';

export default function Layout() {
  const isOnline = useOnline();

  return (
    <div className="app-shell">
      <header className="topbar">
        <NavLink to="/" className="brand" aria-label="Fishing Report powered by Roavyn">
          <img
            className="brand-logo"
            src={roavynArtworkUrl}
            alt="Powered by Roavyn"
          />
          <span className="brand-divider" />
          <span className="brand-product">
            <b>Fishing Report</b>
            <small>Field-ready guide reports</small>
          </span>
        </NavLink>

        {!isOnline && (
          <span className="offline-pill">
            <SafeIcon icon={FiWifiOff} />
            Offline
          </span>
        )}
      </header>

      <main className="main-content">
        <Outlet />
      </main>

      <nav className="bottom-nav" aria-label="Primary navigation">
        <NavLink to="/new">
          <SafeIcon icon={FiFilePlus} />
          <span>New Report</span>
        </NavLink>
        <NavLink to="/reports">
          <SafeIcon icon={FiFolder} />
          <span>My Reports</span>
        </NavLink>
      </nav>
    </div>
  );
}